import { Routes } from '@angular/router';

import { NotFoundComponent } from './components/pages/not-found/not-found.component';
import { AdminGuard } from './guard/admin.guard';

import { MyappsComponent } from './components/pages/myapps/myapps.component';
import { AppLanguageComponent } from './components/pages/myapps/app-language/app-language.component';
import { AppProductsComponent } from './components/pages/myapps/app-products/app-products.component';
import { AppTablesComponent } from './components/pages/myapps/app-tables/app-tables.component';
import { AppInfoComponent } from './components/pages/myapps/app-info/app-info.component';
import { OrdersComponent } from './components/pages/myapps/orders/orders.component';
import { SetupAppComponent } from './components/pages/myapps/setup-app/setup-app.component';
import { AnaliticComponent } from './components/pages/myapps/analitic/analitic.component';

import { SignUpComponent } from './components/pages/auth/sign-up/sign-up.component';
import { SignInComponent } from './components/pages/auth/sign-in/sign-in.component';
import { ResetPassComponent } from './components/pages/auth/reset-pass/reset-pass.component';
import { VerifyComponent } from './components/pages/auth/verify/verify.component';
import { NewPasswordComponent } from './components/pages/auth/new-password/new-password.component';

import { RulesComponent } from './components/pages/rules/rules.component';
import { PricingComponent } from './components/pages/pricing/pricing.component';

export const routes: Routes = [
  {
    path: '',
    component: MyappsComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'pricing',
    component: PricingComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'pey/:result',
    component: MyappsComponent,
    canActivate: [AdminGuard]
  },

  {
    path: 'app/setup/:id',
    component: SetupAppComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'app/orders/:id',
    component: OrdersComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'app/products/:id',
    component: AppProductsComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'app/tables/:id',
    component: AppTablesComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'app/analitic/:id',
    component: AnaliticComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'app/languages/:id',
    component: AppLanguageComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'app/setting/:id',
    component: AppInfoComponent,
    canActivate: [AdminGuard]
  },

  {
    path: 'signin',
    component: SignInComponent
  },
  {
    path: 'signup',
    component: SignUpComponent
  },
  {
    path: 'reset/password',
    component: ResetPassComponent
  },
  {
    path: 'new/password',
    component: NewPasswordComponent
  },
  {
    path: 'verify',
    component: VerifyComponent
  },
  {
    path: 'rules',
    component: RulesComponent
  },

  {
    path: 'not-found',
    component: NotFoundComponent
  },
  {
    path: '**',
    redirectTo: 'not-found'
  }
];